import { render, staticRenderFns } from "./MemberStatus.vue?vue&type=template&id=66d63e22&scoped=true"
import script from "./MemberStatus.vue?vue&type=script&lang=js"
export * from "./MemberStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d63e22",
  null
  
)

export default component.exports